import { render, staticRenderFns } from "./MenuCreateModal.vue?vue&type=template&id=0718ee92&scoped=true"
import script from "./MenuCreateModal.vue?vue&type=script&lang=ts"
export * from "./MenuCreateModal.vue?vue&type=script&lang=ts"
import style0 from "./MenuCreateModal.vue?vue&type=style&index=0&id=0718ee92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0718ee92",
  null
  
)

export default component.exports